import { createComponentSDKModel } from '@wix/editor-elements-integrations/corvid';
import type { ValidationSchema } from '@wix/editor-elements-corvid-utils';
import {
  composeSDKFactories,
  createElementPropsSDKFactory,
  linkPropsSDKFactory,
  backgroundPropsSDKFactory,
  withValidation,
  createAccessibilityPropSDKFactory,
} from '@wix/editor-elements-corvid-utils';
import type {
  TextMaskProps,
  TextMaskSDKFactory,
  TextMaskSDKArgs,
} from '../TextMask.types';

const accessibilityPropsSDKFactory = createAccessibilityPropSDKFactory({
  enableAriaHidden: true,
  enableScreenReader: true,
});

const textMaskSDK: TextMaskSDKFactory = ({
  props,
  setProps,
}: TextMaskSDKArgs) => {
  return {
    get text() {
      return props.text;
    },
    set text(value) {
      setProps({ text: value, viewBox: '0 0 0 0' });
    },
  };
};

const schema: ValidationSchema = {
  type: ['object'],
  properties: {
    text: {
      type: ['string'],
      minLength: 1,
      maxLength: 450,
    },
  },
};

export const textMaskSDKFactory = withValidation(textMaskSDK, schema);

export default createComponentSDKModel(
  composeSDKFactories<TextMaskProps, TextMaskSDKFactory>([
    createElementPropsSDKFactory(),
    linkPropsSDKFactory,
    backgroundPropsSDKFactory,
    accessibilityPropsSDKFactory,
    textMaskSDKFactory,
  ]),
);
